export interface SizeMapping {
    viewport: [number, number]
    slot: SlotSize
    /** If not specified will pick the height of the first size mapping */
    placeholderHeight?: number
}

export type SlotSize = SlotSizeArray | SingleAdSlotSize
export type SlotSizeArray = SingleAdSlotSize[]
export type SingleAdSlotSize = [number, number] | [number, number, 'v']

export function isSlotSizeArray(slot: SlotSize): slot is SlotSizeArray {
    return Array.isArray(slot[0])
}

export type UniqueAdSlotSize = [number, number] | string
export type UniqueSlotSizeArray = UniqueAdSlotSize[]

export function isStandardAdSlotSize(
    slot: UniqueAdSlotSize,
): slot is [number, number] {
    return Array.isArray(slot)
}

export function uniqueSlotSizes(
    sizeMapping: SizeMapping[],
): UniqueSlotSizeArray {
    const sizes: UniqueSlotSizeArray = []
    sizeMapping.forEach((element) => {
        if (isSlotSizeArray(element.slot)) {
            element.slot.forEach((element) => {
                const uniqueSize = getUniqueSlotSizeFromStandardSlot(element)
                if (uniqueSize) {
                    sizes.push(uniqueSize)
                }
            })
        } else {
            const uniqueSize = getUniqueSlotSizeFromStandardSlot(element.slot)
            if (uniqueSize) {
                sizes.push(uniqueSize)
            }
        }
    })
    return sizes.filter(
        (aVal, index, self) =>
            index === self.findIndex((bVal) => equals(aVal, bVal)),
    )
}

export function getUniqueSlotSizeFromStandardSlot(
    size: SingleAdSlotSize,
): UniqueAdSlotSize | undefined {
    // If the size is not defined or has less than 2 elements, return undefined
    if (!size || size.length < 2) {
        return
    }

    const [width, height] = size

    // If either width or height is zero or negative, return undefined
    if (width <= 0 || height <= 0) {
        return
    }

    if (size.length === 3) {
        return `${width}x${height}v`
    } else if (size[0] > 0 && size[1] > 0) {
        return size
    }
}

function equals(a: UniqueAdSlotSize, b: UniqueAdSlotSize) {
    return (
        (typeof a === 'string' && typeof b === 'string' && a === b) ||
        (a[0] === b[0] && a[1] === b[1] && a.length === 2)
    )
}
